import { Button as AntdButton } from 'antd'
import styles from './Button.module.scss'
import cn from 'classnames'

interface IButtonProps {
   children?: React.ReactNode
   variant?: 'primary' | 'secondary'
   size?: 'small' | 'middle' | 'large'
   loading?: boolean
   disabled?: boolean
   shape?: 'default' | 'circle' | 'round'
   ghost?: boolean
   className?: string
   ariaLabel?: string
   icon?: React.ReactNode
   onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const Button = ({
   variant = 'primary',
   children,
   className,
   size = 'large',
   loading = false,
   disabled = false,
   shape = 'default',
   ghost = false,
   onClick,
   ariaLabel,
   icon,
}: IButtonProps) => {
   return (
      <AntdButton
         aria-label={ariaLabel}
         icon={icon}
         children={children}
         className={cn(
            styles.button,
            styles[`${variant}-variant`],
            // styles[`${size}-size`],
            {
               [styles[`${variant}-variant-ghost`]]: ghost,
            },
            className
         )}
         size={size}
         loading={loading}
         disabled={disabled}
         shape={shape}
         ghost={ghost}
         onClick={onClick}
      />
   )
}
